module.exports = (window.__publicpath__ || __webpack_public_path__) + "static/media/win10-start-dark-bgimage.173fb58d.svg";